import React from 'react';
import { Dialog } from '@mui/material';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ArchiveMorphologyStore } from '../ArchiveMorphologyStore';
import '../../shared/RevealConfirmationDialog/RevealConfirmationDialog.less';

const AlmostThereDialog = () => {
  const isOpen = ArchiveMorphologyStore.useState(s => s.toolbar.almostThereIsOpen);

  const onClose = () => {
    ArchiveMorphologyStore.update(s => {
      s.toolbar.almostThereIsOpen = false;
    });
  };

  // This dialog cannot be closed by clicking the backdrop,
  // because allowing that causes it to close instantly on mobile
  // because the final touch keyboard input is still "active" and insta-closes it.
  return (
    <Dialog open={isOpen}>
      <div className="revealConfirmationDialogContent">
        <IconButton className="closeButton" onClick={onClose}>
          <CloseIcon/>
        </IconButton>
        <div className="aboutBody">
          Almost there! You've filled in the puzzle, but at least one square is wrong. The puzzle will tell you when everything is correct.
        </div>
      </div>
    </Dialog>
  );
};

export default AlmostThereDialog;